import { render, staticRenderFns } from "./ProcessDiagramViewer.vue?vue&type=template&id=a80afad0&scoped=true"
import script from "./ProcessDiagramViewer.vue?vue&type=script&lang=js"
export * from "./ProcessDiagramViewer.vue?vue&type=script&lang=js"
import style0 from "./ProcessDiagramViewer.vue?vue&type=style&index=0&id=a80afad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80afad0",
  null
  
)

export default component.exports